import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import BusinessTabs from "examples/Tabs/BusinessTabs";

function CorCar() {
  return (
    <DashboardLayout>
      <BusinessTabs />
    </DashboardLayout>
  );
}

export default CorCar;